export const serviceURL = import.meta.env.VITE_SERVICE
